module.exports = __webpack_public_path__ + "img/app_intro_bg.df161422.jpg";